<template>
    <div v-if="invoice" class="mt-6 w-100">
        <!-- Total sin impuestos ni descuentos (solo se muestra si hay descuento por línea, NO si hay descuento global) -->
        <v-row class="custom-row" v-if="invoice.total_lines_discounts > 0">
            <v-col class="text-right py-0" cols="8" md="6">
                <span>Total sin descuentos</span>
            </v-col>
            <v-col class="text-right custom-total" cols="4" md="2" lg="1">
                <span>{{ invoice.total_gross_amount.toFixed(2) + ' €' }}</span>
            </v-col>
        </v-row>

        <!-- Descuento por linea -->
        <v-row class="custom-row" v-if="invoice.total_lines_discounts > 0">
            <v-col class="text-right py-0" cols="8" md="6">
                <span>Descuento por línea</span>
            </v-col>
            <v-col class="text-right custom-total" cols="4" md="2" lg="1">
                <span>{{ (-invoice.total_lines_discounts).toFixed(2) + ' €' }}</span>
            </v-col>
        </v-row>

        <!-- Total sin impuestos -->
        <v-row class="custom-row">
            <v-col class="text-right py-0" cols="8" md="6">
                <span>Total sin impuestos</span>
            </v-col>
            <v-col class="text-right custom-total" cols="4" md="2" lg="1">
                <span>{{ invoice.total_gross_amount_before_tax.toFixed(2) + ' €' }}</span>
                <!-- <template v-if="invoice.general_discounts && invoice.general_discounts.length > 0">
                    <small class="description">
                        {{ (-invoice.general_discounts[0].amount).toFixed(2) + ' € de Descuento' }}
                    </small>
                </template> -->
            </v-col>
        </v-row>
        
        <!-- Total IVA por tasa -->
        <v-row v-for="item in invoice.total_taxes" :key="item.rate.toString() +'_t'" class="custom-row">
            <v-col class="text-right py-0" cols="8" md="6">
                <span v-if="is_mobile">
                    Total {{ tax_type_to_show }} {{ (item.rate * 100).toFixed(2) }}%  <br/> {{ '(Base: ' + item.base.toFixed(2) + ' €)' }}
                </span>
                <span v-else>
                    Total {{ tax_type_to_show }} {{ (item.rate * 100).toFixed(2) }}% {{ '(Base: ' + item.base.toFixed(2) + ' €)' }}
                </span>
            </v-col>
            <v-col class="text-right custom-total" cols="4" md="2" lg="1">
                <span>{{ item.amount.toFixed(2) + ' €' }}</span>
            </v-col>
        </v-row>
    
        <!-- Total Retención por tasa -->
        <v-row v-for="item in invoice.total_taxes_withheld" :key="item.rate.toString() +'_wt'" class="custom-row">
            <v-col class="text-right py-0" cols="8" md="6">
                <span v-if="is_mobile">
                    Total Retención {{ (item.rate * 100).toFixed(0) }}% <br/> {{ '(Base: ' + item.base.toFixed(2) + ' €)' }}
                </span>
                <span v-else>
                    Total Retención {{ (item.rate * 100).toFixed(0) }}% {{ '(Base: ' + item.base.toFixed(2) + ' €)' }}
                </span>
            </v-col>
            <v-col class="text-right custom-total" cols="4" md="2" lg="1">
                <span>{{ (-item.amount).toFixed(2) + ' €' }}</span>
            </v-col>
        </v-row>
    
        <!-- Total factura -->
        <v-row class="custom-row">
            <v-col class="text-right py-0" cols="8" md="6">
                <span>Total {{invoice.name}}</span>
            </v-col>
            <v-col class="text-right custom-total" cols="4" md="2" lg="1">
                <span>{{ invoice.total_amount.toFixed(2) + ' €' }}</span>
            </v-col>
        </v-row>

        <!-- Descuento global -->
        <v-row class="custom-row" v-if="invoice.general_discounts && invoice.general_discounts.length > 0">
            <v-col class="text-right py-0" cols="8" md="6">
                <span>Descuento global</span>
                <small class="description" v-if="invoice.general_discounts.reason">
                    {{ '(' + invoice.general_discounts[0].reason + ')' }}
                </small>
            </v-col>
            <v-col class="text-right custom-total" cols="4" md="2" lg="1">
                <span>{{ (-invoice.general_discounts[0].amount).toFixed(2) + ' €' }}</span>
            </v-col>
        </v-row>
    
        <!-- Retención -->
        <template v-if="invoice.retention_amount">
            <v-row class="custom-row">
                <v-col class="text-right py-0" cols="8" md="6">
                    <span>Retención: &nbsp; <b>{{ invoice.retention_concept }}</b></span>
                </v-col>
                <v-col class="text-right custom-total" cols="4" md="2" lg="1">
                    <span>{{ -Number(invoice.retention_amount).toFixed(2) + ' €' }}</span>
                </v-col>
            </v-row>
        </template>
    
        <!-- Suplido -->
        <template v-if="invoice.reimbursable_amounts && invoice.reimbursable_amounts.length > 0">
            <v-row class="custom-row">
                <v-col class="text-right py-0" cols="8" md="6">
                    <span>Suplido: &nbsp; <b>{{ invoice.reimbursable_expense_concept }}</b></span>
                </v-col>
                <v-col class="text-right custom-total" cols="4" md="2" lg="1">
                    <span>{{ invoice.reimbursable_amounts[0].toFixed(2) + ' €' }}</span>
                </v-col>
            </v-row>
        </template>
    
        <!-- Total a pagar -->
        <v-row class="custom-row pb-6">
            <v-col class="text-right py-0" cols="8" md="6"> 
                <span class="title-color">Total a pagar</span>
            </v-col>
            <v-col class="text-right custom-total-last" cols="4" md="2" lg="1">
                <span>{{ invoice.total_to_pay.toFixed(2) + ' €' }}</span>
            </v-col>
        </v-row>
    </div>
</template>


<script>

import {Invoiceable} from '../modules/facturae/domain/Invoiceable'
import { mapGetters } from "vuex";

export default {

    props: {
        invoice: {
            type: Invoiceable,
        },
    },
    data() {
        return {
        }
    },


    computed: {
        
        // totalGrossAmountBeforeTaxes(){
        //     let total = 0
        //     for(let i in this.invoice.lines){
        //         let line = this.invoice.lines[i]
        //         total += line.gross_amount
        //     }
        //     if (total){
        //         return Math.trunc(total*100)/100
        //     }
        //     else{
        //         return 0
        //     }
        // },
        tax_type_to_show(){
            if (this.invoice.tax_type == 'igic'){
                return 'IGIC'
            }
            else{
                return 'IVA'
            }
        },
        ...mapGetters(['is_mobile']),
    },
    methods: {
        
        // getTaxes(){
        //     let taxes_comput = {}
        //     for(let i in this.invoice.lines){
        //         let line = this.invoice.lines[i]
        //         let tax = line.taxes[0]
        //         let recargo = line.taxes[0].recargo_amount? line.taxes[0].recargo_amount : 0
        //         if (taxes_comput.hasOwnProperty(tax.rate)){
        //             taxes_comput[tax.rate].TaxableBase += tax.base
        //             taxes_comput[tax.rate].TaxAmount += tax.amount + recargo
        //         }
        //         else{
        //             taxes_comput[tax.rate] = {
        //                 TaxRate: tax.rate*100,
        //                 TaxableBase: tax.base,
        //                 TaxAmount: tax.amount + recargo
        //             }
        //         }
        //     }
        //     let items = []
        //     console.log(taxes_comput)
        //     for (let key in taxes_comput){
        //         items.push(taxes_comput[key])
        //     }
        //     return items
            

        // },
        // getWithheldTaxes(){
        //     let taxes_comput = {}
        //     for(let i in this.invoice.lines){
        //         let line = this.invoice.lines[i]
        //         if (line.taxes_withheld.length){
        //             let tax = line.taxes_withheld[0]
        //             if (taxes_comput.hasOwnProperty(tax.rate)){
        //                 taxes_comput[tax.rate].TaxableBase += tax.base
        //                 taxes_comput[tax.rate].TaxAmount += tax.amount
        //             }
        //             else{
        //                 taxes_comput[tax.rate] = {
        //                     TaxRate: (tax.rate*100).toFixed(2),
        //                     TaxableBase: tax.base,
        //                     TaxAmount: tax.amount
        //                 }
        //             }
        //         }
        //     }
        //     let items = []
        //     for (let key in taxes_comput){
        //         items.push(taxes_comput[key])
        //     }
        //     return items
            

        // },
    },
    

}
</script>


<style scoped>
.custom-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 5px;
}
.custom-total {
    border-radius: 2px;
    border: 1px solid  #56565680;
    padding: 4px;
    width: 150px;
    text-align: right;
    display: flex;
    flex-direction: column;
}

.custom-total-last {
    border-radius: 2px;
    color:var(--v-primary-base); 
    border: 1px solid var(--v-primary-base); 
    padding: 4px;
    width: 150px;
    text-align: right;
}

.description {
    font-size: 0.8em; /* Adjust the size as needed */
    color: gray; /* Adjust the color as needed */
}
</style>